// text fade
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible'); 
    } else {
      entry.target.classList.remove('is-visible'); 
    }
  });
}, {
  threshold: 0.4
});

document.querySelectorAll('.text-fade').forEach(el => {
  observer.observe(el);
});


// text animate
import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from 'split-type';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", (event) => {

  new SplitType("[text-split]", {
    types: "words, chars",
    tagName: "span",
  });

  const elements = document.querySelectorAll("[letters-fade-in]");

  elements.forEach(element => {
    const chars = element.querySelectorAll(".char");

    gsap.to(chars, {
      opacity: 1,
      ease: "power3.out",
      stagger: {
        each: 1,
        from: "start"
      },
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: () => "+=" + window.innerHeight,
        scrub: 5, 
      },
    });
  });
});
